<template>

  <div id="page-user-list">

    <vx-card ref="filterCard" title="Filtros Asesor Asignado" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Asesor asignado</label>
          <v-select :closeOnSelect="true" :clearable="true" v-model="employees_filter" label="name_employee" :options="employees" name="name_employee" class="mb-4 md:mb-0">
            <template #option="{ name_employee, surname_employee }">
              <span>{{ name_employee }} {{ surname_employee }}</span>
            </template>
            <template #selected-option="{ name_employee, surname_employee }">
              <span>{{ name_employee }} {{ surname_employee }}</span>
            </template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">¿Quién asignó el asesor?</label>
          <v-select :closeOnSelect="true" :clearable="true" v-model="employee_generator_filter" label="name_employee" :options="employees" name="name_employee" class="mb-4 md:mb-0">
            <template #option="{ name_employee, surname_employee }">
              <span>{{ name_employee }} {{ surname_employee }}</span>
            </template>
            <template #selected-option="{ name_employee, surname_employee }">
              <span>{{ name_employee }} {{ surname_employee }}</span>
            </template>
          </v-select>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
            <!-- ADD NEW -->
          <!-- <div class="float-left btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Agregar Nuevo</span>
          </div> -->
        </div>
        

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />
          <!-- <vs-button class="mr-4 mb-4 md:mb-0" @click.stop="exportarCsvAll()">Exportar Todo CSV</vs-button> -->
          <!-- <vs-button class="mr-4 mb-4 md:mb-0" @click.stop="exportarCsvSelected()">Exportar Seleccionados CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu class="ancho-dropdown">

              <vs-dropdown-item>
                <span title="Descargar Todo" class="flex items-center" @click.stop="exportarCsvAll()">
                  <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Todo CSV</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span title="Descargar Seleccionados" class="flex items-center" @click.stop="exportarCsvSelected()">
                  <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Seleccionados CSV</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center" v-on:click="sizeToFit()">
                  <feather-icon icon="Minimize2Icon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Ancho ajustado</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center" v-on:click="autoSizeAll()">
                  <feather-icon icon="Maximize2Icon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Ancho Automático</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault=""
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @column-resized="onColumnResized">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererLinkAvatar from './cell-renderer/CellRendererLinkAvatar.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'

//sidebars

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererLinkAvatar,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data () {
    return {
      // Filter Options
      employees_filter: {name_employee: 'Todos', value: 'Todos'},
      employee_generator_filter: {name_employee: 'Todos', value: 'Todos'},

      searchQuery: '',
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Acciones',
          field: 'actions',
          width: 115,
          cellRendererFramework: 'CellRendererActions'
        },
        {
          headerName: 'ID',
          field: 'id_assigned_advisor',
          width: 145,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
          // cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Nombres y Apellidos Cliente',
          filter: true,
          width: 300,
          valueGetter: 'data.names_client + " " + data.surnames_client',
          valueSetter:
            'var nameSplit = newValue.split(" ");' +
            'var newFirstName = nameSplit[0];' +
            'var newLastName = nameSplit[1];' +
            'if (data.names_client !== newFirstName || data.surnames_client !== newLastName) {' +
            '  data.names_client = newFirstName;' +
            '  data.surnames_client = newLastName;' +
            '  return true;' +
            '} else {' +
            '  return false;' +
            '}',
          cellRendererFramework: 'CellRendererLink',
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: 'Email Cliente',
          field: 'email_client',
          filter: true,
          width: 225,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Asesor asignado',
          filter: true,
          width: 300,
          field: 'full_name_employee',
          // cellRendererFramework: 'CellRendererStatus',
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: '¿Quién asignó el asesor?',
          field: 'full_name_generator_employee',
          filter: true,
          width: 240,
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: 'Última Actualización',
          field: 'updated_at_assigned_advisor',
          filter: true,
          width: 320,
          valueFormatter (params) {
            const fecha_requerida = new Date(params.value)
            const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
            return fecha_requerida.toLocaleDateString('es-ES', options)
          },
          cellClass: 'cell-wrap-text',
          autoHeight: true
        }
        
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        // CellRendererLinkAvatar,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {
    employees_filter (obj) {
      this.setColumnFilter('full_name_employee', `${obj.name_employee  } ${  obj.surname_employee}`)
    },
    employee_generator_filter (obj) {
      this.setColumnFilter('full_name_generator_employee', `${obj.name_employee  } ${  obj.surname_employee}`)
    }
    
  },
  computed: {
    usersData () {
      const usersData = this.$store.state.assignedAdvisors
      return usersData.sort((a, b) => Date.parse(b.created_at_assigned_advisor) - Date.parse(a.created_at_assigned_advisor))
    },
    employees () {
      return this.$store.state.employees
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    sizeToFit () {
      this.gridApi.sizeColumnsToFit()
    },
    autoSizeAll () {
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId)
      })
      this.gridColumnApi.autoSizeColumns(allColumnIds)
    },
    onColumnResized () {
      this.gridApi.resetRowHeights()
    },
    updateListClientsPDN () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarClientsPDN() }.bind(this), 0)
    },
    refrescarClientsPDN () {
      this.$store.dispatch('fetchClientsPDN')
        .then(() => { this.$vs.loading.close() })
    },
    refreshCard (card) {
      this.$store.dispatch('fetchClientsPDN')
      card.removeRefreshAnimation(500)
    },
    addNewData () {
      this.sidebarDataAddClientPDN = {}
      this.toggleDataSidebarAddClientPDN(true)
    },
    toggleDataSidebarAddClientPDN (val = false) {
      this.addNewDataSidebarAddClientPDN = val
    },
    exportarCsvSelected () {
    //AQUÍ PARÁMETROS DE EXPORTACIÓN
      const params = {
        onlySelected: true,
        fileName: 'ClientesPDN-Seleccionados'
      }
      this.gridApi.exportDataAsCsv(params)
    },
    exportarCsvAll () {
      //AQUÍ PARÁMETROS DE EXPORTACIÓN
      const params = {
        onlySelected: false,
        fileName: 'ClientesPDN-Todos'
      }
      this.gridApi.exportDataAsCsv(params)
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'Todos') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.employees_filter = {name_employee: '', value: 'Todos', surname_employee: ''}
      this.employee_generator_filter = {name_employee: '', value: 'Todos', surname_employee: ''}

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    this.$store.dispatch('fetchAssignedAdvisors')
      .catch(err => { 
      // console.log(Object.getOwnPropertyNames(err))
      // console.log(err.response)
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err.response.data.error}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })

    if (this.$store.state.employees.length === 0) {
      this.$store.dispatch('fetchEmployees').catch(err => { console.error(err) })
    }

  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.cell-wrap-text {
    white-space: normal !important;
}
.ancho-dropdown {
  width: 15rem;
}
</style>
